import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';

import { useAgGridTableContext } from 'core/states';
import {
  RemovePricingProfilePartNumbersButton,
  UpsertPricingProfilePartNumberButton,
} from 'pricing/components';
import { IPricingProfilePartNumber } from 'pricing/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps {
  data: IPricingProfilePartNumber;
  isEditable?: boolean;
}

export const ActionsCell = ({ data, isEditable = true }: IProps) => {
  const { gridApi } = useAgGridTableContext();

  const refreshTable = () => {
    gridApi?.refreshServerSide();
  };

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <UpsertPricingProfilePartNumberButton
        pricingProfilePartNumber={data}
        structureId={data.structureId}
        buttonElement={
          <Typography
            color={isEditable ? Color.PRIMARY : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <PencilSimpleLine />
          </Typography>
        }
        onSubmitSuccess={refreshTable}
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />
      <RemovePricingProfilePartNumbersButton
        pricingProfilePartNumbers={[data]}
        buttonElement={
          <Typography
            color={isEditable ? Color.DANGER : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <TrashSimple />
          </Typography>
        }
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />
    </Stack>
  );
};
